__turbopack_context__.v({
  "LRIcon": "Items-module__dq0XDa__LRIcon",
  "name": "Items-module__dq0XDa__name",
  "nameMobile": "Items-module__dq0XDa__nameMobile",
});
